import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';

import '../../helpers/fontawesomeLibrary';

const CustomColumnHeader = (props) => {
  const [ascSort, setAscSort] = useState('inactive');
  const [descSort, setDescSort] = useState('inactive');
  const [noSort, setNoSort] = useState('inactive');
  const [isfilteActive, setIsfilteActive] = useState(false);
  const refButton = useRef(null);

  const onMenuClicked = () => {
    props.showColumnMenu(refButton.current);
  };

  const onSortRequested = (order, event) => {
    props.setSort(order, event.shiftKey);
  };

  useEffect(() => {
    const onFilterChanged = () => {
      setIsfilteActive(props.column.isFilterActive());
    };
    const onSortChanged = () => {
      setAscSort(props.column.isSortAscending() ? 'active' : 'inactive');
      setDescSort(props.column.isSortDescending() ? 'active' : 'inactive');
      setNoSort(
        !props.column.isSortAscending() && !props.column.isSortDescending()
          ? 'active'
          : 'inactive'
      );
    };
    props.column.addEventListener('sortChanged', onSortChanged);
    onSortChanged();
    props.column.addEventListener('filterChanged', onFilterChanged);
    return () => {
      props.column.removeEventListener('sortChanged', onSortChanged);
      props.column.removeEventListener('filterChanged', onFilterChanged);
    };
  }, [props.column]);

  let menu = null;
  if (props.enableMenu) {
    menu = (
      <span
        aria-role="button"
        ref={refButton}
        className="ag-header-icon"
        onClick={() => onMenuClicked()}
        aria-label={isfilteActive ? 'filterIcon' : 'menuIcon'}
      >
        {isfilteActive ? (
          <FontAwesomeIcon
            className="fa-sharp filter-icon"
            icon={['fas', 'filter']}
          />
        ) : (
          <FontAwesomeIcon icon={['fas', 'bars']} size="1x" />
        )}
      </span>
    );
  }

  let sort = null;
  if (props.enableSorting) {
    sort = (
      <span style={{ display: 'inline-block' }}>
        <span
          onClick={(event) => onSortRequested('asc', event)}
          onTouchEnd={(event) => onSortRequested('asc', event)}
          className={`customSortDownLabel ${ascSort}`}
        >
          <FontAwesomeIcon icon={['fas', 'long-arrow-alt-down']} size="md" />
        </span>
        <span
          onClick={(event) => onSortRequested('desc', event)}
          onTouchEnd={(event) => onSortRequested('desc', event)}
          className={`customSortUpLabel ${descSort}`}
        >
          <FontAwesomeIcon icon={['fas', 'long-arrow-alt-up']} size="md" />
        </span>
        <span
          onClick={(event) => onSortRequested('', event)}
          onTouchEnd={(event) => onSortRequested('', event)}
          className={`customSortRemoveLabel ${noSort}`}
        >
          <FontAwesomeIcon icon={['fas', 'times']} size="md" />
        </span>
      </span>
    );
  }
  return (
    <div
      style={{ justifyContent: 'center' }}
      className="aep-grid ag-cell-label-container"
      aria-label={`${props.displayName} Menu`}
      role="presentation"
    >
      <span className="customHeaderLabel">{props.displayName}</span>
      {sort}
      {props.column.colDef.enableMenu && menu}
    </div>
  );
};

export default CustomColumnHeader;
